<template>
  <div>
    <Breadcrumbs main="Inventario" title="Categorías"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div v-if="!clientInput.value">
                <h5>No hay un cliente seleccionado.</h5>
                <span >Debes seleccionar un cliente para visualizar sus categorías</span>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <select name="client" id="" class="form-control" v-on:change="updateNesTable(clientInput.value)" v-model="clientInput.value">
                    <option value="">Seleccionar cliente</option>
                    <option :value="client.id" v-for="client in clientInput.options" :key="client.id">{{client.business_name}} - {{client.rut}}</option>
                  </select>
                </div>
                <div class="col-6" v-if="clientInput.value">
                  <div class="pull-right">
                    <b-button class="mr-2" variant="primary" size="sm" v-on:click="updateNesTable(clientInput.value)">
                      <i class="fa fa-refresh"></i> Actualizar
                    </b-button>
                    <b-button variant="success" size="sm" :to="{name: 'InventoryCategoryForm', params: { clientId: clientInput.value }}">
                      <i class="icon-palette"></i> Agregar categoría
                    </b-button>
                  </div>
                </div>
              </div>

            </div>
            <div class="card-body">
              <vue-nestable v-model="nestableItems">
                <div slot="placeholder" v-if="!clientInput.value">
                  <b>No hay categorías a mostrar</b>
                  <p>Debes seleccionar un cliente para visualizar sus categorías.</p>
                </div>
                <div slot="placeholder" v-else>
                  <b>No hay categorías a mostrar</b>
                  <p>El cliente {{clientInput.value.name}} no tiene categorías registradas.</p>
                </div>
                <div draggable="false"
                     slot-scope="{ item }">
                  {{ item.name }}
                  <span class="badge badge-danger" v-if="item.deleted">Eliminado</span>
                  <span class="badge badge-success" v-if="item.status && !item.deleted">Habilitado</span>
                  <span class="badge badge-danger" v-else-if="!item.status && !item.deleted">Deshabilitado</span>
                  <div class="pull-right">
                    <a href="javascript:void(0);" title="Modificar" v-on:click="editObject(item)" v-if="!item.deleted"><span class="badge badge-primary"><i class="fa fa-pencil"></i></span></a>
                    <a href="javascript:void(0);" title="Deshabilitar" class="ml-1" v-on:click="editStatusObject(item)" v-if="item.status && !item.deleted"><span class="badge badge-warning"><i class="fa fa-times"></i></span></a>
                    <a href="javascript:void(0);" title="Habilitar" class="ml-1" v-on:click="editStatusObject(item)" v-else-if="!item.status && !item.deleted"><span class="badge badge-success"><i class="fa fa-check"></i></span></a>
                    <a href="javascript:void(0);" title="Eliminar" class="ml-1" v-on:click="editDeletedObject(item)" v-if="!item.deleted"><span class="badge badge-danger"><i class="fa fa-trash"></i></span></a>
                  </div>
                </div>
              </vue-nestable>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
  import axios from 'axios';
  import { VueNestable } from 'vue-nestable'
  import utils from "../../../utils";

  export default {
    components: {
      VueNestable,
    },
    data () {
      return {
        clientInput: {
          value: '',
          name: '',
          options: []
        },
        nestableItems: []
      }
    },
    mounted() {
      if(this.$route.params.clientId){
        this.clientInput.value = this.$route.params.clientId;
        this.updateNesTable(this.clientInput.value);
      }
      this.getClient(this.clientInput);
    },
    methods: {
      async updateNesTable(clientId){
        if(!clientId){
          this.nestableItems = [];
          return;
        }
        this.nestableItems = await this.getObjects(clientId);
      },
      getClient(client_field){
        const path = '/api/core/v1.0/client/';
        const filter = {
          status: true,
          deleted: false
        };
        axios.get(path, {params: filter}).then((response) => {
          if(response.status === 200){
            client_field.options = response.data;
          }
        });
      },
      async getObjects(clientId) {
        let items;
        const path = `/api/inventory/v1.0/category/`;
        const config = {
          params : {
            deleted: false,
            level: 0,
            client: clientId
          }
        };
        await axios.get(path, config).then(async (response) => {
          items = response.data;
        }).catch((error) => {
          console.log(error.response);
        });
        return items;
      },
      async editObject(row) {
        this.$router.push({'name': 'InventoryCategoryFormEdit', params: {objectId: row['id'], clientId: this.clientInput.value}});
      },
      async editStatusObject(row) {
        let message = '';
        if(row['status']){
          message = `Estás a punto de <b>deshabilitar</b> la categoría <b>${row['name']}</b>. Al deshabilitar una categoría <b>todas</b> sus subscategorías serán <b>deshabilitadas</b>.`;
        } else {
          message = `Estás a punto de <b>habilitar</b> la categoría <b>${row['name']}</b>. Al habilitar una categoría <b>todas</b> las categorías padres serán <b>habilitadas</b>.`;
        }
        this.$swal({
          title: 'Información',
          type: 'info',
          html: message,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonColor: '#28a745',
          confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
          cancelButtonColor: '#dc3545',
          cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            const path = '/api/inventory/v1.0/category/' + row['id'] + '/';
            let data = {status: !row['status']};
            const response = await utils.updateObject(path, data);
            // SI SE REALIZA EL CAMBIO
            if(response){
              await this.$swal({
                title: 'Editado!',
                type: 'success',
                html: `Se ha editado el estado de la categoría de manera correcta.`,
              });
              await this.updateNesTable(this.clientInput.value);
            }
          }
        });
      },
      async editDeletedObject(row) {
        this.$swal({
          title: 'Información',
          type: 'info',
          html: `Estás a punto de <b>eliminar</b> la categoría <b>${row['name']}</b>. Al eliminar una categoría <b>todas</b> las subcategorías serán <b>eliminadas</b>.`,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonColor: '#28a745',
          confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
          cancelButtonColor: '#dc3545',
          cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            const path = '/api/inventory/v1.0/category/' + row['id'] + '/';
            let data = {deleted: true};
            const response = await utils.updateObject(path, data);
            // SI SE REALIZA EL CAMBIO
            if (response) {
              await this.$swal({
                title: 'Eliminado!',
                type: 'success',
                html: `Se ha eliminado la categoría de manera correcta.`,
              });
              this.updateNesTable(this.clientInput.value);
            }
          }
        });
      },
    }
  }
</script>

<style>
  .nestable-item-content {
    display: block;
    height: 30px;
    margin: 5px 0;
    padding: 5px 10px;
    color: #333;
    text-decoration: none;
    font-weight: bold;
    border: 1px solid #ccc;
    background: #fafafa;
    border-radius: 3px;
    box-sizing: border-box;
  }
  .nestable {
    position: relative;
  }
  .nestable .nestable-list {
    padding: 0 0 0 20px!important;
  }
  .nestable .nestable-list {
    list-style-type: none;
  }
  .nestable-list-empty {
    text-align: center;
  }
</style>